import { createStore, combineReducers, compose, applyMiddleware } from "redux";
import reducer from "./reducers/reducer.js";
import thunk from "redux-thunk";

const store = createStore(
  combineReducers({ reducer }),
  compose(
    applyMiddleware(thunk),
    window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : (f) => f
  )
);

export default store;
